import { IApplicationState } from '../../types/redux';

export function selectIsDropdownOpen(state: IApplicationState): boolean {
  return state.infrastructure.isDropdownOpen;
}
